var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountBadgeBackImageAttachmentKey, accountBadgeEntityName, accountBadgeFrontImageAttachmentKey, } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { PartialError } from '@juvare/common-web-ui/PartialError';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useAttachmentDataUrl } from '@juvare/platform-sdk-react/ui/hooks';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FlipOutlinedIcon from '@mui/icons-material/FlipOutlined';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import React from 'react';
import { useDownloadAccountBadgeAttachments } from '../../badge-management/hooks/useDownloadAccountBadgeAttachments';
import { validateBase64DataString } from '../utils/validateBase64DataString';
export const AccountBadgePreview = ({ accountBadge, enablePrintedPdfDownload }) => {
    const [visibleAccountBadgeSide, setVisibleAccountBadgeSide] = React.useState('front');
    const { t } = useBadgingTranslation();
    const { downloadAccountBadgeAttachment } = useDownloadAccountBadgeAttachments();
    const attachmentFrontResponse = useAttachmentDataUrl(accountBadgeEntityName, accountBadge.id, accountBadgeFrontImageAttachmentKey, undefined, undefined, undefined, {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
    });
    const attachmentBackResponse = useAttachmentDataUrl(accountBadgeEntityName, accountBadge.id, accountBadgeBackImageAttachmentKey, undefined, undefined, undefined, {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
    });
    if (attachmentFrontResponse.error) {
        return React.createElement(PartialError, { title: t('badgePreview.errorMessage') });
    }
    if ((visibleAccountBadgeSide === 'front' && attachmentFrontResponse.isLoading) ||
        (visibleAccountBadgeSide === 'back' && attachmentBackResponse.isLoading)) {
        return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(CircularProgress, null)));
    }
    const attachmentFront = validateBase64DataString(attachmentFrontResponse.data);
    const attachmentBack = validateBase64DataString(attachmentBackResponse.data);
    const handleFlipAccountBadgeSide = () => {
        setVisibleAccountBadgeSide((prevState) => (prevState === 'front' ? 'back' : 'front'));
    };
    const handleDownloadPDF = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield downloadAccountBadgeAttachment({
                accountBadgeId: accountBadge.id,
                accountDisplayName: accountBadge.columns.accountDisplayName,
            });
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { component: 'img', sx: {
                width: '100%',
                borderRadius: 1,
                borderWidth: 1,
                borderColor: themeColors.border.main,
                borderStyle: 'solid',
            }, src: visibleAccountBadgeSide === 'back' ? attachmentBack : attachmentFront }),
        React.createElement(Stack, { direction: 'row', spacing: 2 },
            Boolean(attachmentBack) && (React.createElement(Button, { startIcon: React.createElement(FlipOutlinedIcon, null), onClick: handleFlipAccountBadgeSide }, t('badgePreview.flipBadge'))),
            enablePrintedPdfDownload && accountBadge.columns.printStatus === 'success' && (React.createElement(Button, { startIcon: React.createElement(FileDownloadOutlinedIcon, null), onClick: () => void handleDownloadPDF() }, t('badgePreview.downloadPDF'))))));
};
